export default __webpack_public_path__ + "static/media/40310.5e158a8e.jpg";